var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loading",attrs:{"data-test-id":"loading-indicator"}},[_c('div',{staticClass:"spinning-background"}),_c('BriqIcon',{attrs:{"name":"icon-beeldmerk"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }